import { useContext, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import is from "is_js";
import MainLayout from "./MainLayout";
import SettingsPanel from "../components/settings-panel/SettingsPanel";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { CloseButton } from "../components/common/Toast";

import AppContext from "../context/Context";
import Landing from "../app/components/pages/landing/Landing";

import ErrorLayout from "./ErrorLayout";
import Error404 from "../components/errors/Error404";
import Error500 from "../components/errors/Error500";

import BlDetails from "../app/features/blDetails/BlDetails";
import BlPayment from "../app/features/blPayment/BlPayment";
import Payment from "../app/features/payment/Payment";
import AuthCardLayout from "./AuthCardLayout";
import Registration from "../app/features/registration/Registration";

import DocumentView from "../app/common/components/DocumentView";
import StandingInstruction from "../app/features/standingInstruction/StandingInstruction";
import PaymentDashboard from "../app/features/paymentdashboard/PaymentDashboard";

import { useLocation } from "react-router-dom";
import queryString from "query-string";
import LoginForm from "../app/features/registration/LoginForm";
import ForgotPasswordPage from "../app/features/registration/ForgotPasswordPage";
import ResetPasswordPage from "../app/features/registration/ResetPasswordPage";
import ChangePasswordPage from "../app/features/registration/ChangePasswordPage";
import SetupPasswordPage from "../app/features/registration/SetupPasswordPage";
import EmailVerifyPage from "../app/features/registration/EmailVerifyPage";
import ProfileAccount from "../app/features/profile/ProfileAccount";
import { useSelector } from "react-redux";
import AccountDtls from "../app/features/profile/AccountDtls";
import UserDetails from "../app/features/createUser/UserDetails";
import User from "../app/features/createUser/User";
import CustomerMappingDtls from "../app/features/profile/CustomerMappingDtls";
import InstructionDtls from "../app/features/instructionDashboard/instructionDetails";
import PaymentFund from "../app/features/paymentFund/PaymentFund";
import ConsumerNominateAgent from "../app/features/dashboard/components/ConsumerNominateAgent";
import ConsigneeNominateAgent from "../app/features/dashboard/components/ConsigneeNominateAgent";
import BlanketDelegation from "../app/features/dashboard/components/BlanketDelegation";
import InstructionMapper from "../components/common/InstructionMapper";
import EInstructionMapper from "../components/common/EInstructionMapper";
import RegistrationDetails from "../app/features/registrationMaster/components/registrationDetails";
import { AESDecrypt, AESEncryptAny } from "../encrypt-util";

import ReportDashboard from "../app/features/reportDashboard/ReportDashboard";
import Snooze from "../app/features/blRequestInstruction/components/Snooze";
import InvoiceUnpaid from "../app/features/crrpop/InvoiceUnpaid";
import QuickPay from "../app/features/quickpay/QuickPay";
import QuickPayment from "../app/features/quickpay/PaymentQuickPay";
import Commonapp from "../app/components/Commonapp";
import AuthCardLayoutNew from "./AuthCardLayoutNew";
import ReceiptDashboard from "../app/features/receiptDashboard/receiptDashboard";
import EmailDashboard from "../app/features/emailDashboard/emailDashboard";
import PayorDashboard from "../app/features/payorDashboard/payorDashboard";
import GetInGetOutDashboard from "../app/features/getInGetOutDashboard/getInGetOutDashboard";
import MappingDashboard from "../app/features/customerMappingDashboard/MappingDashboard";
import SezDashboard from "../app/features/sezDashboard/SezDashboard";
import SezCertUpload from "../app/features/sezDashboard/SezCertUpload";
import SezApproveReject from "../app/features/sezDashboard/SezApproveReject";
import SezHistory from "../app/features/sezDashboard/SezHistory";
import CustomerDetailsSlider from "../app/features/customerMappingDashboard/MappingCustomerDetailsSlider";
import EditUserSlider from "../app/features/customerMappingDashboard/MappingEditUserSlider";
import AddCodeSlider from "../app/features/customerMappingDashboard/MappingAddCodeSlider";
import OblDetails from "../app/common/components/OblDetails";
import EmailBodyDetails from "../app/features/emailDashboard/EmailBodyDetails";


import TruckerMasterDashboard from "../app/features/truckerMasterDashboard/TruckerMasterDashboard";
import TruckerMaster from "../app/features/dashboard/components/TruckerMaster";
import TemplateUploadScreen from "../app/features/template/TemplateUploadScreen";
import DashboardContainer from "../components/common/DashboardContainer";
import FormSubmission from "../app/features/template/TemplateFormSubmission";
import { getUnprefixedPathname } from "../helpers/utils";

import ManualInvoice from "../app/features/payment/ManualInvoice";
import EmailTemplateDashboard from "../app/features/emailTemplate/emailTemplateDashboard";
import EmailTemplateDtls from "../app/features/emailTemplate/emailTemplateDtls";
import BulkPaymentDashboard from "../app/features/bulkuploaddashboard/BulkUploadDashboard";
import BulkPayment from "../app/features/dashboard/components/BulkPaymentConfiguration";
import { useBackNavigation } from "../hooks/BackNavigation";
import AddCustomerDetails from "../app/features/customerMappingDashboard/AddCustomerDetails";
import DocumentManagementDashboard from "../app/features/documentManagment/DocumentManagmentDashboard";
import UploadDocument from "../app/features/documentManagment/UploadDocument";
import NewBlRequest from "../app/features/payorDashboard/NewBlRequest";
import CustomerCodeDashboard from "../app/features/customerCodeDashboard/CustomerCodeDashboard";
import CustomerCodeRequest from "../app/features/customerCodeDashboard/CustomerCodeRequest";
import CustomerCodeDetails from "../app/features/customerCodeDashboard/CustomerCodeDetails";
import SarsCustomDetails from "../app/features/blDetails/SarsCustomDetails";
import RuleEngineConfig from "../app/features/ruleEngineConfig/RuleEngineConfig";
import InvoiceRequest from "../app/features/invoiceRequest/InvoiceRequest";
import SezAnalyticsCharts from "../app/features/sezDashboard/Analytics";
import ReportsDashboard from "../app/features/sezDashboard/Reports";
import { canAccessBulkPayment, canAccessPdfParser, canAccessRegisterationMst } from "../helpers/rbac";
import ProtectedRoute from "../routes/ProtectedRoute";

const Layout = () => {
  const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  const profileDetails = useSelector((state) => state.userProfile.profile);
  const isDirty = useSelector((state) => state.formDirty.isDirty);
  const gridName = useSelector(
    (state) => state.navbarTop.selectedDashbaordName
  );
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  useContext(AppContext);


  useEffect(() => {
    console.log("APP_PATH_PREFIX -> " + APP_PATH_PREFIX);
    if (is.windows()) {
      HTMLClassList.add("windows");
    }
    if (is.chrome()) {
      HTMLClassList.add("chrome");
    }
    if (is.firefox()) {
      HTMLClassList.add("firefox");
    }
  }, [HTMLClassList]);

  const location = useLocation();

  useEffect(() => {
    const query = queryString.parse(location.search);
    if (query?.setActiveUser) {
      window.localStorage.setItem("@odex/activeuser", AESEncryptAny(query.setActiveUser));
      window.location.href = `${APP_PATH_PREFIX}/home`;
    }
  }, []);
  const parts = getUnprefixedPathname().split("/");
  const page = decodeURIComponent(parts[parts.length - 1]);
  const decpage = parts.length != 3 ? "" : AESDecrypt(page);

  return (
    <>
      <Routes>
        <>
          <Route
            path={APP_PATH_PREFIX ? `${APP_PATH_PREFIX}` : '/'}
            element={<Landing />}
          />

          <Route path={`${APP_PATH_PREFIX}/app`} element={<Commonapp />} />

           <Route element={<AuthCardLayoutNew />}>
             <Route path="register" element={<Registration />} />
           </Route>

           <Route path="resetpassword" element={<ResetPasswordPage />} />
           <Route path="forgotPassword" element={<ForgotPasswordPage />} />
           <Route path="/forgot-password" element={<ForgotPasswordPage />} />
           <Route path="/reset-password" element={<ResetPasswordPage />} />
           <Route path="/change-password" element={<ChangePasswordPage />} />
           <Route path="/setup-password" element={<SetupPasswordPage />} />
           <Route path="/verify-email" element={<EmailVerifyPage />} />
           <Route path="quickPay" element={<QuickPay />}>
             <Route path="pay" element={<QuickPayment />} />
           </Route>

          <Route element={<MainLayout />}>
            <Route
              element={
                <ProtectedRoute
                  check={canAccessPdfParser}
                />
              }
            >
              <Route path="templateUpload" element={<TemplateUploadScreen />}>
                <Route path="add" element={<FormSubmission />} />
              </Route>
            </Route>

            <Route path={`${APP_PATH_PREFIX}/user/profile`} element={<ProfileAccount />}>
              <Route path="details/:accountId" element={<AccountDtls />} />
              <Route
                path="custMapDetails/:custMapId"
                element={<CustomerMappingDtls />}
              />
            </Route>

            <Route path={`${APP_PATH_PREFIX}/mappingdashboard`} element={<MappingDashboard />}>
              <Route
                path="addcustomerdetails"
                element={<AddCustomerDetails />}
              />
              <Route path="customerdetails/:custId" />
              <Route
                path="customerdetails/:custId/edituser"
                element={<EditUserSlider />}
              />
              <Route
                path="customerdetails/:custId/edituser/:userId"
                element={<EditUserSlider />}
              />
              <Route
                path="customerdetails/:custId/addcode"
                element={<AddCodeSlider />}
              />
            </Route>
            <Route
              path={`${APP_PATH_PREFIX}/sezAnalytics`}
              element={<SezAnalyticsCharts />}
            />
               <Route
              path={`${APP_PATH_PREFIX}/sezReports`}
              element={<ReportsDashboard />}
            />
            <Route path={`${APP_PATH_PREFIX}/sezDashboard`} element={<SezDashboard />}>
              <Route path="certificate/:sez_cert_req_id" element={<SezCertUpload />} />
              <Route path="certificate/:sez_cert_req_id/review" element={<SezApproveReject />} />
              <Route path="history/:sez_cert_req_id" element={<SezHistory />} />
            </Route>
            <Route path={`${APP_PATH_PREFIX}/emailTemplateDashboard`} element={<EmailTemplateDashboard />} >
              <Route path=":email_template_id" element={<EmailTemplateDtls backPath={`${APP_PATH_PREFIX}/emailTemplateDashboard`} />} />
            </Route>
            <Route path={`${APP_PATH_PREFIX}/payment-fund`} element={<PaymentFund />} />
            <Route path={`${APP_PATH_PREFIX}/paymentDashboard`} element={<PaymentDashboard />} />
						<Route
						  element={
						    <ProtectedRoute
						      check={canAccessBulkPayment}
						    />
						  }
						>
						  <Route path="bulkpaymentDashboard" element={<BulkPaymentDashboard />}>
						    <Route path="bulkpayment" element={<BulkPayment />}>
						      <Route
						        path=":bulk_payment_process_config_id"
						        element={<BulkPayment />}
						      />
						    </Route>
						  </Route>
						</Route>
            <Route path={`${APP_PATH_PREFIX}/receipt`} element={<ReceiptDashboard />} />
            <Route path={`${APP_PATH_PREFIX}/emailDashboard`} element={<EmailDashboard />} >

              <Route path=":email_logs_id" element={<EmailBodyDetails />} />
            </Route>
            <Route path={`${APP_PATH_PREFIX}/exportBlDashboard`} element={<PayorDashboard />} >
              <Route path="newBlRequest" element={<NewBlRequest backPath={`${APP_PATH_PREFIX}/exportBlDashboard`} />} />
              <Route path="newBlRequest/:newblid" element={<NewBlRequest backPath={`${APP_PATH_PREFIX}/exportBlDashboard`}  />} />
            </Route>
            <Route path="truckMasterDashboard" element={<TruckerMasterDashboard />} >

              <Route path="truckMaster" element={<TruckerMaster />} >
                <Route path=":master_trucker_id" element={<TruckerMaster />} />
              </Route>

            </Route>
            <Route path={`${APP_PATH_PREFIX}/gateinout`} element={<GetInGetOutDashboard />} />
            <Route path={`${APP_PATH_PREFIX}/documentManagment`} element={<DocumentManagementDashboard />}>
              <Route path={`uploadDocument`} element={<UploadDocument backPath="/documentManagment"/>}>
                <Route path=":docId"/>
              </Route>
            </Route>
            <Route path={`${APP_PATH_PREFIX}/users`} element={<UserDetails />}>
              <Route path="details/:userID" element={<User />} />
            </Route>
            <Route path={`${APP_PATH_PREFIX}/customerCode`} element={<CustomerCodeDashboard />}>
              <Route path="request" element={<CustomerCodeRequest />} />
              <Route
                path="companyDetails/:custId"
                element={<CustomerCodeDetails />}
              />
              {/* <Route path="request/:requestID" element={<CustomerCodeRequest />} /> */}
            </Route>
            <Route path={`${APP_PATH_PREFIX}/home`} element={<BlDetails />} />
            <Route path={`${APP_PATH_PREFIX}/blslider`} element={<BlDetails />}>
              <Route path=":blNum" element={<OblDetails />} />
            </Route>
            <Route path={`${APP_PATH_PREFIX}/blsliderinvoice/:blNum`} element={<Payment />} />
            <Route
              path={`${APP_PATH_PREFIX}/blsliderpayment/:blNum`}
              element={
                gridName == "PAYMENT_DASHBOARD" ? (
                  <PaymentDashboard />
                ) : (
                  <Payment />
                )
              }
            >

              <Route index element={<BlPayment />} />
            </Route>

            <Route path={`${APP_PATH_PREFIX}/payment`} element={<Payment />}>
              <Route path=":blNum" />
              <Route path="new" element={<BlPayment />} />
              <Route path="manualinvoice" element={<ManualInvoice backPath={`${APP_PATH_PREFIX}/payment`} />} />
              <Route path="addInvoice">
                <Route path="invoicePayment" element={<BlPayment />} />
              </Route>
            </Route>
            
            <Route path={`${APP_PATH_PREFIX}/report`} element={<ReportDashboard />} />
            {profileDetails?.partnerType !== "liner" && (
              <Route path="multiBl/:blNum" element={<BlDetails />}>
                <Route
                  path="instruction/:encrypt"
                  element={<InstructionMapper />}
                />
              </Route>
            )}
            {/*Standing Dashboard*/}
            <Route path={`${APP_PATH_PREFIX}/standing`} element={<StandingInstruction />}>
              <Route path=":encrypt" element={<BlanketDelegation />} />
              <Route
                path=":blNum/:encrypt/:encryptdoc"
                element={<BlanketDelegation />}
              />
            </Route>
            {/*Instruction Dashboard*/}
            <Route path={`${APP_PATH_PREFIX}/instruction`} element={<InstructionDtls />}>
              <Route path="snooze/:blEventId" element={<Snooze />}></Route>

           

              <Route path=":blNum" />
              <Route
                path=":blNum/:encrypt/:encryptdoc"
                element={<InstructionMapper />}
              />
              {/*liner */}
              {(decpage == "811" || decpage == "815") && (
                <Route path={page} element={<ConsumerNominateAgent />} />
              )}
              {/*customer*/}
              {(decpage == "812" || decpage == "813") && (
                <Route path={page} element={<ConsigneeNominateAgent />} />
              )}
              {decpage == "822" && (
                <Route path={page} element={<InvoiceRequest />} />
              )}
              <Route path="bl/:blNum">
                <Route path=":encrypt" element={<InstructionMapper />} />
                <Route
                  path=":encrypt/:encryptdoc"
                  element={<InstructionMapper />}
                />
                <Route path="snooze/:blEventId" element={<Snooze />}></Route>
                <Route path=":docType" element={<DocumentView />} />
                <Route path="payment/:blId" element={<BlPayment />} />
                <Route path=":encrypt/unpaid" element={<InvoiceUnpaid />} />
                <Route path=":encrypt/unpaid/payment" element={<BlPayment />} />
                <Route path=":encrypt/unpaid/payment/:pmtid" element={<BlPayment />} />
                {profileDetails?.partnerType !== "liner" && (
                  <Route path="instruction">
                    <Route path=":encrypt" element={<InstructionMapper />} />
                    <Route
                      path=":encrypt/:blId"
                      element={<InstructionMapper />}
                    />
                  </Route>
                )}
              </Route>
            </Route>
            {/*Resgistration Master Dashboard*/}
            <Route
              element={
                <ProtectedRoute
                  check={canAccessRegisterationMst}
                />
              }
            >
              <Route
                path={`${APP_PATH_PREFIX}/registrationmaster`}
                element={<RegistrationDetails />}
              />
            </Route>
            <Route
              path={`${APP_PATH_PREFIX}/blsliderinstruction/:blNum`}
              element={<InstructionDtls />}
            />
            <Route
              path={`${APP_PATH_PREFIX}/registrationmaster/:requestId`}
              element={<RegistrationDetails />}
            />
            {profileDetails?.partnerType === "liner" ? (
              <Route path={`${APP_PATH_PREFIX}/payment/bl/:blNum`} element={<Payment />}>
                <Route path=":encrypt" element={<InstructionMapper />} />
                <Route
                  path=":encrypt/:encryptdoc"
                  element={<InstructionMapper />}
                />
                <Route path="snooze/:blEventId" element={<Snooze />}></Route>
                <Route path=":docType" element={<DocumentView />} />
                <Route path="payment/:blId" element={<BlPayment />} />
              </Route>
            ) : (
              <Route path={`${APP_PATH_PREFIX}/payment/bl/:blNum`} element={<Payment />}>
                <Route path=":encrypt" element={<InstructionMapper />} />
                <Route
                  path=":encrypt/:encryptdoc"
                  element={<InstructionMapper />}
                />
                <Route path=":docType" element={<DocumentView />} />
                <Route path=":encrypt/unpaid" element={<InvoiceUnpaid />} />
                <Route path=":encrypt/unpaid/payment" element={<BlPayment />} />
                <Route path=":encrypt/unpaid/payment/:pmtid" element={<BlPayment />} />
                <Route path="instruction">
                  <Route path=":encrypt" element={<InstructionMapper />} />
                  <Route
                    path=":encrypt/:blId"
                    element={<InstructionMapper />}
                  />
                </Route>
                <Route path="payment/:blId" element={<BlPayment />} />
              </Route>
            )}
            <Route path={`${APP_PATH_PREFIX}/bl/:blNum`} element={<BlDetails />}>
              <Route path="payment/:blId" element={<BlPayment />} />
              <Route path=":encrypt" element={<InstructionMapper />} />

              <Route path="snooze/:blEventId" element={<Snooze />}></Route>

              <Route
                path=":encrypt/:encryptdoc"
                element={<InstructionMapper />}
              ></Route>
              <Route path=":docType" element={<DocumentView />} />
              <Route path=":encrypt/unpaid/payment" element={<BlPayment />} />
              <Route path=":encrypt/unpaid" element={<InvoiceUnpaid />} />
              <Route path=":encrypt/unpaid/payment/:pmtid" element={<BlPayment />} />
              {profileDetails?.partnerType !== "liner" && (
                <Route path="instruction">
                  <Route path=":encrypt" element={<InstructionMapper />} />
                  <Route
                    path=":encrypt/:blId"
                    element={<InstructionMapper />}
                  />
                </Route>
              )}
            </Route>
            <Route path={`${APP_PATH_PREFIX}/ebl/:blId`} element={<BlDetails />}>
              {profileDetails?.partnerType !== "liner" && (
                <Route path="instruction">
                  <Route path=":encrypt" element={<EInstructionMapper />} />
                  <Route
                    path=":encrypt/:blId"
                    element={<EInstructionMapper />}
                  />
                </Route>
              )}
            </Route>
            <Route
              path={`${APP_PATH_PREFIX}/sarscustomdetails/:blid`}
              element={<BlDetails />}>
              <Route index element={<SarsCustomDetails />} />
            </Route>
            <Route
              path={`${APP_PATH_PREFIX}/ruleengineconfig`}
              element={<RuleEngineConfig />}
            />
          </Route>

          {/* //--- MainLayout Starts  */}

          {/* //--- MainLayout end  */}

          <Route element={<ErrorLayout />}>
            <Route path="errors/404" element={<Error404 />} />
            <Route path="errors/500" element={<Error500 />} />
          </Route>
        </>
      </Routes>
      <SettingsPanel />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="top-right"
        autoClose={5000}
      />
    </>
  );
};

export default Layout;
